<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12  pdb-0"
    :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
    ]">
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
                             :error="errors.length > 0"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="errors = []"/>
      </div>

      <div class="column is-12 mgt-5px">
        <a @click="toggleBrief()">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">{{$t('ajoutDevis.brief')}}</span>
      </div>

      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">{{$t('ajoutDevis.appliquerBrief')}}</span>
      </div>

    </div>

    <div class="column columns is-multiline is-12 overflow-auto is-marginless is-paddingless"
         :class="[
           {'hauteur-brief-filtre': errors.length === 0},
           {'hauteur-brief-filtre-errors': errors.length > 0}
         ]">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.modeDiffusion')" class="obligatoire">
          <b-select v-model="brief.produitLocationNum"
                    @input="brief.saturation = brief.produitLocationNum.saturation"
                    expanded>
            <option
              v-for="typeSaturation in produitLocationNumerique"
              :key="typeSaturation.id"
              :value="typeSaturation">
              {{typeSaturation.libelle}}
              <span v-if="typeSaturation.reference"> - {{typeSaturation.reference}} </span>
            </option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.saturation')">
          <div class="columns is-marginless is-vcentered">
                      <span class="column is-narrow has-text-link
                        is-size-6 is-paddingless mgr-5px">
                        {{$t('ajoutDevis.saturationLabel')}}
                      </span>
            <b-select
              class="column is-paddingless pdl-5px"
              :disabled="!brief.saturation"
              v-model="brief.saturation">
              <option v-for="saturation in 12" :value="saturation" :key="saturation">
                {{ saturation }}
              </option>
            </b-select>
          </div>
        </b-field>
      </div>

      <div class="column is-12 columns is-marginless is-paddingless">
        <div class="column is-6 pdb-0">
          <b-field :label="$t('ajoutDevis.informations.from')">
            <b-datepicker show-week-number
            class="datePickerSmallWidth"
              icon="calendar-today"
              :editable="true"
              v-model="brief.dateDebut"
              :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-6 pdb-0">
          <b-field :label="$t('ajoutDevis.informations.to')">
            <b-datepicker show-week-number
            class="datePickerSmallWidth datePickerFloatRight"
              icon="calendar-today"
              :editable="true"
              v-model="brief.dateFin"
              position="is-bottom-left"
              :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
      </div>

      <div class="column is-12 pdb-0">
        <div v-for="day in brief.daySelected" :key="day.numero">
          <button
            class="button-brief"
            :class="[
                  {'is-primary' : day.selected},
                  {'is-select' : !day.selected}]"
            @click="day.selected = !day.selected"
            type="submit"
          >
            <span
              class="is-size-7"
              :class="[{'has-text-white' : day.selected},
                    {'has-text-default' : !day.selected}]"
            >{{returnDayUpperCase(day.nom)}}</span>
          </button>
        </div>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.copieDcf.fieldLabel')">
          <b-autocomplete
            :data="dcfData"
            icon="magnify"
            field="code"
            v-model="brief.copieLibelle"
            :loading="isFetching"
            :check-infinite-scroll="true"
            @typing="getAsyncDataDcf"
            @select="getDcfSelect"
            @infinite-scroll="getMoreAsyncDataDcf">

            <template slot-scope="props">
              <div>
                <p>
                  <span class="has-text-weight-bold">{{ props.option.code }}</span> <br/>
                  {{ props.option.creationTime | formatDate }}
                  {{ props.option.theme ? ' - ' + props.option.theme : '' }} <br/>
                  {{ props.option.getAnnonceur }} <br/>
                  {{ props.option.getPayeurs }}
                </p>
              </div>
            </template>
          </b-autocomplete>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.libelle')">
          <b-input v-model="critereRecherche.libelle">
          </b-input>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.enseignePrincipale')">
          <qd-taginput v-model="critereRecherche.enseignePrincipale" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.enseignesMarques')">
          <qd-taginput v-model="critereRecherche.enseigneMarque" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.ville')">
          <ville-tag-input-auto-complete
              :critere-recherche="this.critereRecherche"
              table-name="Produit"/>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.departements')">
          <qd-taginput v-model="critereRecherche.departements" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.agglomeration')">
          <qd-taginput v-model="critereRecherche.agglomeration" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.nbHabitants')">
          <b-field>
            <b-select v-model="critereRecherche.nbHabitants.operateur" expanded>
              <option
                v-for="item in typeOperateursHabitants"
                :key="item.code"
                :value="item.code"
              >{{$t(item.libelle)}}</option>
            </b-select>
            <b-input type="search" v-model="critereRecherche.nbHabitants.valeur"/>
          </b-field>
        </b-field>
      </div>

      <div class="column is-12 pdb-0">
        <b-field :label="$t('ajoutDevis.budgetMax')">
          <input-currency v-model="brief.budgetMax"
            isNumber="true">
          </input-currency>
        </b-field>
      </div>

      <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
      && !filtrerProduitParSociete && !filtrerProduitParAgence">
        <b-field :label="$t('reseauTempo.briefContent.societe')">
          <b-select v-model="critereRecherche.societeId" expanded>
            <option :value=null></option>
            <option v-for="societe in societesInformations"
                    :key="societe.id"
                    :value="societe.id">
              {{ societe.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>

    <div class="column is-12 hauteur-bas-brief-filtre border-pied pdt-0">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="saveBrief()"
      >{{$t('ajoutDevis.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pdl-10px"
        @click="viderBrief()"
      >{{$t('ajoutDevis.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import getDaysOfWeek from '@/services/general/getDaysOfWeek';
import { getAll } from '@/api/produit/produitLocation';
import validationBrief from '@/services/devisCommandes/validationBrief';
import * as typesProduitNumerique from '@/store/modules/produitEcranNumerique-mutation-type';
import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT_NUMERIQUE } from '@/configuration/catalogue/produitConf';
import inputCurrency from '@/components/general/inputCurrency';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { getDcfByType } from '@/services/devisCommandes/devisCommandeGetter';
import devisCommandeFactureGetAllByType from '@/services/devisCommandes/devisCommandeFactureGetAllByType';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';

const produitNumerique = createNamespacedHelpers('produitEcranNumerique');
const societe = createNamespacedHelpers('societe');
const Commande = createNamespacedHelpers('commande');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'DevisCommandesBrief',
  data() {
    return {
      brief: null,
      produitLocationNumerique: [],
      errors: [],
      typeOperateursHabitants: devisConf.LISTE_HABITANTS_OPERATEURS,
      dcfData: [],
      isFetching: false,
      codeDcf: '',
      page: 1,
      totalPages: 1,
    };
  },
  components: {
    inputCurrency,
    errorMsgComponent,
    VilleTagInputAutoComplete,
  },
  props: {
    critereRecherche: Object,
  },
  computed: {
    ...produitNumerique.mapGetters({
      briefStocke: 'brief',
      typeProduits: 'typeProduits',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      societesInformations: 'societesInformations',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...produitNumerique.mapMutations({
      setBrief: typesProduitNumerique.SET_BRIEF,
      clearBrief: typesProduitNumerique.CLEAR_BRIEF,
    }),
    returnDayUpperCase(nom) {
      return nom.charAt(0).toUpperCase() + nom.slice(1);
    },
    viderBrief() {
      this.clearBrief();
      this.brief = cloneDeep(this.briefStocke);
      this.brief.daySelected = getDaysOfWeek();
      this.$emit('viderCritere');
    },
    saveBrief() {
      this.errors = [];
      validationBrief(this.brief, this.errors);
      if (this.errors.length === 0) {
        this.setBrief(this.brief);
        this.toggleBrief();
        this.$emit('appliquerBrief');
      }
    },
    toggleBrief() {
      this.$emit('toggleBrief');
    },
    getAsyncDataDcf: debounce(async function get(code) {
      try {
        if (this.codeDcf !== code) {
          this.codeDcf = code;
          this.dcfData = [];
          this.page = 1;
          this.totalPages = 1;
        }
        if (!code.length) {
          this.dcfData = [];
          this.page = 1;
          this.totalPages = 1;
          return;
        }
        if (this.page > this.totalPages) {
          return;
        }
        this.isFetching = true;
        const result = await devisCommandeFactureGetAllByType(this.commandeCourante.type, {
          query: {
            societeId: this.societeActiveId,
            code: this.codeDcf,
            sens: devisConf.SENS_VENTE,
          },
          page: this.page,
          limit: 10,
        });
        result.items.forEach((item) => this.dcfData.push({
          ...item,
          getAnnonceur: this.$t('ajoutDevis.copieDcf.annonceur') + item.intervenants.filter(int => int.annonceur).map(el => el.nomCommercial).join(', '),
          getPayeurs: this.$t('ajoutDevis.copieDcf.payeur') + item.intervenants.filter(int => int.payeur).map(el => el.nomCommercial).join(', '),
        }));
        this.page += 1;
        this.totalPages = result.totalCount;
        this.isFetching = false;
      } catch (error) {
        this.isFetching = false;
        throw error;
      }
    }, 500),
    getMoreAsyncDataDcf: debounce(function getMore() {
      this.getAsyncDataDcf(this.codeDcf);
    }, 250),
    async getDcfSelect(dcfSelected) {
      if (!dcfSelected) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const reponse = await getDcfByType(this.commandeCourante.type, dcfSelected.id);
        this.critereRecherche.produitsId = reponse.lignesCommande
          .filter(el => el.typeProduit === this.typeProduits)
          .map(el => el.produitId);
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
        throw error;
      }
    },
  },
  async created() {
    let idProduitLocSociete = null;
    const queryItem = {
      query: {
        societeId: this.societeActiveId,
        numerique: true,
      },
      orderBy: 'ProduitLocation.Quantite, Libelle',
      ascending: true,
      maxResultCount: NO_PAGINATION,
    };
    this.brief = cloneDeep(this.briefStocke);
    if (this.brief.daySelected.length === 0) {
      this.brief.daySelected = getDaysOfWeek();
    }
    if (this.typeProduits === CATEGORIE_REGROUPEMENT_NUMERIQUE
      && this.societeActive.produitIdDefautRegroupementNumerique) {
      idProduitLocSociete = this.societeActive.produitIdDefautRegroupementNumerique;
    } else if (this.typeProduits !== CATEGORIE_REGROUPEMENT_NUMERIQUE
      && this.societeActive.produitIdDefautEcranNumerique) {
      idProduitLocSociete = this.societeActive.produitIdDefautEcranNumerique;
    }
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
      PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key]);
    this.resultLocationNumerique = (await getAll(queryItem)).data.result.items;
    this.produitLocationNumerique = this.resultLocationNumerique.map(el => {
      return {
        id: el.id,
        libelle: el.libelle,
        reference: el.reference,
        saturation: el.produitLocation.saturation,
      };
    });
    if (idProduitLocSociete) {
      const produitLocationNum = await this.produitLocationNumerique.find((loc) => {
        return loc.id === idProduitLocSociete;
      });
      if (produitLocationNum) {
        this.brief.produitLocationNum = produitLocationNum;
        this.brief.saturation = produitLocationNum.saturation;
      }
    }
  },
};
</script>
